import React, { ReactNode } from 'react';
import { WorkInProgressBanner } from './WorkInProgressBanner';

interface BaseNodeWrapperProps {
  children: ReactNode;
  workInProgress?: boolean;
  wipBannerOffset?: number;
  isEditing?: boolean;
  onUpdate?: (updates: { wipBannerOffset?: number }) => void;
  overflow?: 'visible' | 'hidden';
}

export const BaseNodeWrapper: React.FC<BaseNodeWrapperProps> = ({
  children,
  workInProgress = false,
  wipBannerOffset = 0,
  isEditing = false,
  onUpdate,
  overflow = 'visible',
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: overflow,
        background: 'transparent',
      }}
    >
      {children}
      {workInProgress && (
        <WorkInProgressBanner
          initialOffset={wipBannerOffset}
          isEditing={isEditing}
          onOffsetChange={(offset) => onUpdate?.({ wipBannerOffset: offset })}
        />
      )}
    </div>
  );
};
